import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import './index.css';
import App from './App';
import { msalInstance } from './auth/msalConfig';
import reportWebVitals from './reportWebVitals';

msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise().then(() => {
    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
    );
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );
  });
});

reportWebVitals();
